export enum BreakingErrors {
	FailedToLoadProducts = 'failed_to_load_products',
	FailedToLoadUserData = 'failed_to_load_user_data',
	FailedToLoadCustomerData = 'failed_to_load_customer_data',
	TechnicalDifficulties = 'technical_difficulties',
	ClientSideError = 'client_side_error'
}
